"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var dealerPageTitleStyles = styles_1.makeStyles(function (theme) { return ({
    titleContainer: {
        display: 'flex',
        verticalAlign: 'center',
        justifyContent: 'center',
        width: '100%',
        padding: '40px 0',
    },
    title: {
        fontWeight: 'bold',
        alignSelf: 'center',
        textTransform: 'uppercase',
        color: theme.palette.text.primary,
    },
}); }, { name: 'GqlCheckout_DealerPageTitle' });
exports.default = dealerPageTitleStyles;
